import React from 'react';
import { css } from '@emotion/react';
import { useThemeContext } from '../ui/ThemeContext';
import { staticWebinarDimensions, withWebinarPlayerContext } from './context';
import { motion } from 'framer-motion';
import { ChatType } from '$/GraphQL/schema/schema';

export const BackgroundGradient: React.FC<{
  className?: string;
  placement: 'top' | 'bottom';
  height?: string;
  width?: string;
}> = withWebinarPlayerContext(
  ['dimensions', 'transitions', 'isCollapsedEmbeddedPlayer', 'chatType'],
  'BackgroundGradient'
)(({
  placement,
  className,
  height,
  width,
  context: { dimensions, transitions, isCollapsedEmbeddedPlayer, chatType },
}) => {
  const etheme = useThemeContext();
  if (!height) {
    height = `${staticWebinarDimensions.actionsPane.whiteOutHeightRem}rem`;
  }

  if (!width) {
    width = `${dimensions.actionsPane.idock.widthRem}rem`;
  }

  let paddingTop = `${staticWebinarDimensions.chat.paddingBottomRem + 3}rem`;
  if ([ChatType.None, ChatType.ThirdParty].includes(chatType as ChatType)) {
    paddingTop = '0';
  }

  return (
    <motion.div
      id='BackgroundGradient'
      className={`${placement} z-player-whiteout ${className}`}
      css={css`
        position: absolute;
        pointer-events: none;
        right: 0;
        height: ${height};
        ${isCollapsedEmbeddedPlayer ? 'visibility: hidden;' : ''}
        &.top {
          top: 0;
          background: linear-gradient(
            0deg,
            ${etheme.player.bg}00 0%,
            ${etheme.player.bg}ff 30%,
            ${etheme.player.bg}ff 100%
          );
        }
        &.bottom {
          bottom: 0;
          padding: ${paddingTop} 0 ${staticWebinarDimensions.chat.paddingBottomRem + 0.25}rem;
          background: linear-gradient(
            ${etheme.player.bg}00 0%,
            ${etheme.player.bg}ff 30%,
            ${etheme.player.bg}ff 100%
          );
        }
      `}
      animate={{ width }}
      transition={{
        ...transitions['video.resize'],
        delay: 0.25 /* Add delay to not see this over video as it grows */,
      }}
    />
  );
});
